import { request } from '@/utilities/request';
import { endpoint } from '@/config/endpoint';

const service = {
  getExpenses: (user) => request.get({ endpoint: endpoint.expenses, user }),
  getExpenseBills: (query, user) =>
    request.get({ endpoint: endpoint.expenseBills, query, user }),
};
for (const [action, method] of [
  ['create', 'post'],
  ['update', 'put'],
  ['delete', 'del'],
]) {
  for (const [entity, url] of [
    ['Expense', endpoint.expenses],
    ['ExpenseBill', endpoint.expenseBills],
  ]) {
    service[action + entity] = (data, user) =>
      request[method]({ endpoint: url, data, user });
  }
}
export default service;
